function initMap() {
    if (typeof mapLocationsLatLng !== 'undefined' && mapLocationsLatLng.length > 0) {
        const style = [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            }
        ];

        const map = new google.maps.Map(document.getElementById("map"), {
            center: {lat: 25.7612034, lng: -80.19098},
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom: 10,
            styles: style
        });

        const marker = null;

        mapLocationTabClick(map, marker);
    }
}

function mapLocationTabClick(map, marker) {
    const mapLocationTabs = document.querySelectorAll('.map-location');

    mapLocationTabs.forEach((tab) => {

        tab.addEventListener('click', (event) => {
            let locationId = tab.getAttribute('data-location-id'),
                locationCoordinates = mapLocationsLatLng[locationId].placeCoordinates,
                markerLatLng = new google.maps.LatLng(locationCoordinates.lat, locationCoordinates.lng);

            if ( marker !== null ) {
                marker.setMap(null);

                marker = new google.maps.Marker({
                    position: locationCoordinates,
                    icon: 'https://flex.stagingsites.es/wp-content/themes/flexfunds/assets/images/icons/map-marker.svg'
                });

                marker.setMap(map);
                map.setZoom(12);
            } else {
                marker = new google.maps.Marker({
                    position: locationCoordinates,
                    icon: 'https://flex.stagingsites.es/wp-content/themes/flexfunds/assets/images/icons/map-marker.svg'
                });

                marker.setMap(map);
                map.setZoom(12);
            }

            map.panTo(markerLatLng);

            if ( event.currentTarget.classList.contains('active') ) {
                event.currentTarget.classList.remove('active');
                marker.setMap(null);
                map.setZoom(9);
            } else {
                mapLocationTabs.forEach((tabItem) => {
                    if( tabItem.classList.contains('active') ) {
                        tabItem.classList.remove('active');
                    }
                });

                event.currentTarget.classList.add('active');
            }
        });

        // tab.addEventListener('dblclick', (event) => {
        //     if ( marker != null ) {
        //         marker.setPosition();
        //     }
        //
        //     event.currentTarget.classList.remove('active');
        // });
    })
}


export default initMap;


